module.exports = __webpack_public_path__ + "media/search.e643ef80.mp4";